import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, Trash2, Calendar, Package } from "lucide-react";
import { adminEnquiries, adminApproveEnquiry, adminDeclineEnquiry, adminDeleteEnquiry, apiError } from "../../lib/api";
import { Btn, StatusPill } from "./AdminKit";

export default function AdminEnquiries() {
  const [list, setList] = useState([]);

  const load = () => adminEnquiries().then(setList).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    try { await adminApproveEnquiry(id); toast.success("Approved. A booking has been created."); load(); }
    catch (err) { toast.error(apiError(err)); }
  };
  const decline = async (id) => {
    try { await adminDeclineEnquiry(id); toast.success("Enquiry declined."); load(); }
    catch (err) { toast.error(apiError(err)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete this enquiry?")) return;
    try { await adminDeleteEnquiry(id); toast.success("Deleted."); load(); }
    catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div>
      <h1 className="font-display font-bold text-2xl text-nead-navy">Hire Enquiries</h1>
      <p className="mt-1 text-sm text-nead-navy/55">Quote requests from the public hire page. Approve to create a booking.</p>

      <div className="mt-8 space-y-4">
        {list.map((e) => (
          <div key={e.id} data-testid={`enquiry-${e.id}`} className="rounded-2xl border border-black/[0.07] bg-white p-6">
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <div className="flex items-center gap-3">
                  <h3 className="font-display font-bold text-lg text-nead-navy">{e.customer_name}</h3>
                  <StatusPill status={e.status} />
                </div>
                <div className="mt-1 text-sm text-nead-navy/60">
                  <a href={`mailto:${e.email}`} className="hover:text-nead-pink">{e.email}</a>
                  {e.phone ? ` · ${e.phone}` : ""}{e.organisation ? ` · ${e.organisation}` : ""}
                </div>
              </div>
              <div className="flex gap-2">
                {e.status === "pending" && (
                  <>
                    <Btn variant="green" onClick={() => approve(e.id)} data-testid={`enquiry-approve-${e.id}`}><Check className="h-4 w-4" /> Approve</Btn>
                    <Btn variant="outline" onClick={() => decline(e.id)} data-testid={`enquiry-decline-${e.id}`}><X className="h-4 w-4" /> Decline</Btn>
                  </>
                )}
                <Btn variant="ghost" onClick={() => remove(e.id)} data-testid={`enquiry-delete-${e.id}`}><Trash2 className="h-4 w-4" /></Btn>
              </div>
            </div>
            <div className="mt-4 grid sm:grid-cols-2 gap-4 text-sm">
              <div className="flex items-start gap-2 text-nead-navy/70"><Calendar className="h-4 w-4 mt-0.5 text-nead-navy/40" /> {e.date_from || "?"} to {e.date_to || "?"}</div>
              <div className="flex items-start gap-2 text-nead-navy/70"><Package className="h-4 w-4 mt-0.5 text-nead-navy/40" />
                <span>{(e.items || []).map((i) => `${i.quantity}× ${i.name}`).join(", ")}</span>
              </div>
            </div>
            {e.event_details && <p className="mt-3 text-sm text-nead-navy/60 bg-nead-mist rounded-lg p-3">{e.event_details}</p>}
          </div>
        ))}
        {!list.length && <div className="rounded-2xl border border-black/[0.07] bg-white p-10 text-center text-nead-navy/40">No enquiries yet.</div>}
      </div>
    </div>
  );
}
